import type { SVGProps } from 'jsx-dom-cjs'

/**
 * Get the SVG tag <use> for the sprite
 * @param options Options
 * @param options.name - SVG name
 * @param options.attributes - SVG attributes
 * @param options.srOnlyText - SVG alternative text
 * @returns HTML or HTMLElement for the SVG tag <use>
 */
export default function Svg({
	name,
	attributes = {},
	srOnlyText = ''
}: {
	name: string
	attributes?: SVGProps<SVGSVGElement>
	srOnlyText?: string
}) {
	const defaultAttributes: object = {
		'aria-hidden': true.toString(),
		focusable: false.toString()
	}

	// className/class attribute is not supported
	// biome-ignore lint : noDelete rule can't be used here
	delete attributes.className
	// biome-ignore lint : noDelete rule can't be used here
	delete attributes.class

	const attributesMerged = Object.assign({}, defaultAttributes, attributes || {})

	const svg = (
		// biome-ignore lint: attributes are set by destructuring (seems not detected)
		<svg className={`icon icon-${name}`} {...attributesMerged}>
			<use href={`#${name}`} />
		</svg>
	)

	if (srOnlyText) {
		return (
			<>
				<span className="sr-only">{srOnlyText}</span>
				{svg}
			</>
		)
	}

	return svg
}
